// extracted by mini-css-extract-plugin
module.exports = {"completion":"completion_completion__3eiKP","iconButton":"completion_iconButton__2GJgc","buttonGroup":"completion_buttonGroup__1N3C5","linkBtn":"completion_linkBtn__1rBgn"};